import React from 'react';

export default self => [
  {
    title: '用户名',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '角色',
    dataIndex: 'get_role_display',
    key: 'get_role_display',
  },
  {
    title: '所属机构',
    dataIndex: 'organization_name',
    key: 'organization_name',
  },
  {
    title: '电话',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 190,
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 80,
    render: (t, item) => (
      <div>
        <a
          onClick={() => {
            self.setModals({
              key: 'updateForm',
              title: '编辑用户',
              item,
              visible: true,
            });
          }}
        >
          编辑
        </a>
      </div>
    ),
  },
];
